import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthProvider';
import { router } from '@/router';
import { RETRY_BACKOFF_MAX_MS, retryBackoffMs } from '@/lib/freshness';

/**
 * Retries use the same back-off the disconnected banner counts down, so what
 * the operator is told and what the client is doing are the same thing.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: (attempt) => Math.min(RETRY_BACKOFF_MAX_MS, retryBackoffMs(attempt + 1)),
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
